import gql from 'graphql-tag';

export default gql`
  query ordersExport($sort: [OrderSort], $filter: OrderFilterInput, $regionCodes: [String]) {
    ordersExport(sort: $sort, filter: $filter, regionCodes: $regionCodes) {
      content
    }
  }
`;
